import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect';
import Paginate from 'vuejs-paginate';
import apiUrl from '../../../../constants';
import resultGridOfRMAproval from '../../../B2B components/resultGridOfRMAproval';
import rmApprovalActionComponent from '../../../B2B components/rmApprovalActionComponent'
import { variables } from '../../../../../config';
import axios from 'axios';
import {bulkAcceptDispute,searchapiForRMapprovalPage} from '../../../../services/externalDispute';
import {getClientList} from '../../../../services/B2b/services/getClientList';
import swal from 'sweetalert';






export default {
  name: 'OperationExecutivePage',
  components: {
    VueElementLoading,
    Paginate,
    Multiselect,
    resultGridOfRMAproval,
    rmApprovalActionComponent
  },
  data() {
    return {
      awbnumber: '',
      token: '',
      pageValue: 0,
      showResultLoading: false,
      listUserData: [],
      isLoading: false,
      pagecount: 1,
      pageno: 0,
      myStr:'',
      clienList:[],
      showActionColumn:false,
      fieldsAccessData: {},
      defaultSearch : {},
      alldata:{}
    }
  },
    mounted() {
    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.searchData();
    this.listOfClientData();
  },
  methods: {

    editShipment(awb) {
      this.$router.push({ path: '/editRMApprovalPending',query: { awb: awb}});
    },
     async listOfClientData() {
      this.clienList = await getClientList(this.myStr);     
    },
    searchData(pageNo,awbnumber,clientid,shipmentType,disputeReason,daysOperator,numberOfDays,octroi_MRP,operator,assignee,inputVeriable='') {
      this.isLoading = true
      this.showResultLoading=true
      this.listUserData = [];this.pagecount = 1; this.totalRows = '';
      this.exportdis = 1;
      this.totalcount = 0
      var formats= /[`!@#$%^&*()_+\-=\[\]{};':"\\|.<>\/?~]/
      if(formats.test(this.awbnumber))
      {
        this.$alertify.error("Please Search Comma Seprated Shippingids")

      }
        let input = ({
          offset: pageNo?pageNo:0,
          limit: variables.pageRecordLimit,
          shippingid:awbnumber,
          status:20,
          actionstatuscode : '29',
          operator: operator,
          netvalue: octroi_MRP,
        });
        if(inputVeriable != '') input = this.defaultSearch;
        this.defaultSearch = input;

        if(clientid && clientid.length > 0){
          let clientArray = clientid.map(clients => clients.id);
          input.client = clientArray;
        }
        if(shipmentType && shipmentType != '') input.shipmentType = shipmentType;

        if(assignee && assignee != '') input.assignee = assignee;

        if(disputeReason && disputeReason != '') input.disputeReason = disputeReason.toString();

        if(this.client && this.client.length > 0){
          input.client = this.client.map(clients => clients.id);
        }

        if(this.shipmentType && this.shipmentType != '') input.shipmentType = this.shipmentType.id;
        if(daysOperator && numberOfDays && numberOfDays != ''){
          input.daysOperator = daysOperator;
          input.numberOfDays = numberOfDays;
        }
        searchapiForRMapprovalPage(input, this.myStr)
        .then(result => {
          this.showResultLoading = false
          this.listUserData = result.data.data;
          this.totalcount = result.data.count?result.data.count:0
          if (this.totalcount == undefined) {
            this.totalcount = 0
          }
          
          if (this.totalcount < variables.pageRecordLimit) {
            this.pagecount = 1
          } else {
            this.pagecount = Math.ceil(result.data.count / variables.pageRecordLimit)
          }

        })
    },
  acceptDispute(ShippingIDs) {
    if(ShippingIDs.length<=0)swal("Please select the shipment", {icon: "warning"});
    else {
    swal({
      title: "Are you sure?",
      text: `you want to accept the dispute for ${ShippingIDs.length} shipments ?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        swal("Shipments are marked as dispute", {icon: "success"});
        ShippingIDs.forEach((ele) => {
          this.showResultLoading = true
          let input = {
            shippingid: ele.shippingid,
            username: window.localStorage.getItem('username'),
            actionstatuscode: '30'
          }
          bulkAcceptDispute(input, this.myStr).then(result => {
            if (result.data.ReturnCode == 100) {
              //this.$alertify.success(result.data.ReturnMessage);
              this.searchData();
    
            } else {
              this.$alertify.error(result.ReturnMessage);
            }
            this.showResultLoading = false
          })
        })
      }
    });
  }
  },
    getPaginationData(pageNum,input='') {
      localStorage.setItem('pageNum', pageNum)
      this.pageValue = pageNum - 1;
      this.pageno = (pageNum - 1) * variables.pageRecordLimit
      this.searchData(this.pageno,input)
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/RMApproval/rmApprovalPending/rmApprovalPending.component.js